import React from 'react'
import ExitSign from './ExitSign'
import { useGTagEvent, EVENT_TYPES } from '../../utils/hooks';

const Dorms: React.FC<{ setMapLocation: () => void }> = ({
  setMapLocation
}) => {
  useGTagEvent(EVENT_TYPES.VISIT, {
    place: 'dorms'
  })

  return (
    <svg
      width="902"
      height="768"
      viewBox="0 0 902 768"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="902" height="768" fill="white" />
      <rect width="902" height="768" rx="15" fill="#DFDFDF" />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="902"
        height="768"
      >
        <rect width="902" height="768" rx="15" fill="#51B77B" />
      </mask>
      <g mask="url(#mask0)">
        <ExitSign setMapLocation={() => setMapLocation('main-campus')} />
        <rect
          x="10"
          y="10"
          width="882"
          height="748"
          stroke="#7F3333"
          strokeWidth="20"
        />
        <rect x="31" y="24" width="249" height="30" rx="2" fill="#CC8427" />
        <path
          d="M51.3828 42.472L45.1668 32.2H48.7668L53.0388 39.424L57.3108 32.2H60.9108L54.6948 42.472V49H51.3828V42.472ZM67.5605 49.192C66.2965 49.192 65.1765 48.928 64.2005 48.4C63.2405 47.856 62.4885 47.104 61.9445 46.144C61.4165 45.168 61.1525 44.04 61.1525 42.76V38.44C61.1525 37.16 61.4165 36.04 61.9445 35.08C62.4885 34.104 63.2405 33.352 64.2005 32.824C65.1765 32.28 66.2965 32.008 67.5605 32.008H70.1045C71.3685 32.008 72.4805 32.28 73.4405 32.824C74.4165 33.352 75.1685 34.104 75.6965 35.08C76.2405 36.04 76.5125 37.16 76.5125 38.44V42.76C76.5125 44.04 76.2405 45.168 75.6965 46.144C75.1685 47.104 74.4165 47.856 73.4405 48.4C72.4805 48.928 71.3685 49.192 70.1045 49.192H67.5605ZM70.1045 46.264C71.0325 46.264 71.7765 45.928 72.3365 45.256C72.9125 44.584 73.2005 43.704 73.2005 42.616V38.584C73.2005 37.496 72.9125 36.616 72.3365 35.944C71.7765 35.272 71.0325 34.936 70.1045 34.936H67.5605C66.6325 34.936 65.8805 35.272 65.3045 35.944C64.7445 36.616 64.4645 37.496 64.4645 38.584V42.616C64.4645 43.704 64.7445 44.584 65.3045 45.256C65.8805 45.928 66.6325 46.264 67.5605 46.264H70.1045ZM84.8557 49.192C83.6717 49.192 82.6317 48.944 81.7357 48.448C80.8397 47.936 80.1437 47.224 79.6477 46.312C79.1517 45.4 78.9037 44.344 78.9037 43.144V32.2H82.2157V43.048C82.2157 44.008 82.4557 44.784 82.9357 45.376C83.4317 45.968 84.0717 46.264 84.8557 46.264H87.3997C88.1997 46.264 88.8477 45.968 89.3437 45.376C89.8397 44.784 90.0877 44.008 90.0877 43.048V32.2H93.3997V43.144C93.3997 44.344 93.1517 45.4 92.6557 46.312C92.1597 47.224 91.4557 47.936 90.5437 48.448C89.6317 48.944 88.5837 49.192 87.3997 49.192H84.8557ZM96.2732 32.2H105.201C106.657 32.2 107.825 32.592 108.705 33.376C109.601 34.16 110.049 35.192 110.049 36.472V38.152C110.049 38.984 109.809 39.712 109.329 40.336C108.865 40.944 108.185 41.408 107.289 41.728V41.776C107.801 42.112 108.185 42.496 108.441 42.928C108.713 43.36 108.977 43.96 109.233 44.728L110.577 49H107.145L105.873 45.016C105.665 44.328 105.377 43.816 105.009 43.48C104.641 43.144 104.185 42.976 103.641 42.976H99.5852V49H96.2732V32.2ZM104.577 40.12C105.249 40.12 105.777 39.944 106.161 39.592C106.545 39.224 106.737 38.752 106.737 38.176V36.616C106.737 36.152 106.593 35.784 106.305 35.512C106.017 35.224 105.633 35.08 105.153 35.08H99.5852V40.12H104.577ZM121.781 49C121.093 49 120.533 48.792 120.101 48.376C119.669 47.96 119.453 47.416 119.453 46.744V32.2H127.469C128.749 32.2 129.869 32.44 130.829 32.92C131.805 33.4 132.557 34.08 133.085 34.96C133.629 35.84 133.901 36.856 133.901 38.008V42.712C133.901 44.776 133.365 46.344 132.293 47.416C131.221 48.472 129.645 49 127.565 49H121.781ZM127.469 46.072C128.493 46.072 129.269 45.776 129.797 45.184C130.325 44.592 130.589 43.72 130.589 42.568V38.152C130.589 37.24 130.293 36.512 129.701 35.968C129.109 35.408 128.333 35.128 127.373 35.128H122.765V46.072H127.469ZM142.232 49.192C140.968 49.192 139.848 48.928 138.872 48.4C137.912 47.856 137.16 47.104 136.616 46.144C136.088 45.168 135.824 44.04 135.824 42.76V38.44C135.824 37.16 136.088 36.04 136.616 35.08C137.16 34.104 137.912 33.352 138.872 32.824C139.848 32.28 140.968 32.008 142.232 32.008H144.776C146.04 32.008 147.152 32.28 148.112 32.824C149.088 33.352 149.84 34.104 150.368 35.08C150.912 36.04 151.184 37.16 151.184 38.44V42.76C151.184 44.04 150.912 45.168 150.368 46.144C149.84 47.104 149.088 47.856 148.112 48.4C147.152 48.928 146.04 49.192 144.776 49.192H142.232ZM144.776 46.264C145.704 46.264 146.448 45.928 147.008 45.256C147.584 44.584 147.872 43.704 147.872 42.616V38.584C147.872 37.496 147.584 36.616 147.008 35.944C146.448 35.272 145.704 34.936 144.776 34.936H142.232C141.304 34.936 140.552 35.272 139.976 35.944C139.416 36.616 139.136 37.496 139.136 38.584V42.616C139.136 43.704 139.416 44.584 139.976 45.256C140.552 45.928 141.304 46.264 142.232 46.264H144.776ZM153.672 32.2H162.6C164.056 32.2 165.224 32.592 166.104 33.376C167 34.16 167.448 35.192 167.448 36.472V38.152C167.448 38.984 167.208 39.712 166.728 40.336C166.264 40.944 165.584 41.408 164.688 41.728V41.776C165.2 42.112 165.584 42.496 165.84 42.928C166.112 43.36 166.376 43.96 166.632 44.728L167.976 49H164.544L163.272 45.016C163.064 44.328 162.776 43.816 162.408 43.48C162.04 43.144 161.584 42.976 161.04 42.976H156.984V49H153.672V32.2ZM161.976 40.12C162.648 40.12 163.176 39.944 163.56 39.592C163.944 39.224 164.136 38.752 164.136 38.176V36.616C164.136 36.152 163.992 35.784 163.704 35.512C163.416 35.224 163.032 35.08 162.552 35.08H156.984V40.12H161.976ZM169.937 32.2H172.889L178.385 42.184L183.761 32.2H186.713V49H183.473V38.368L179.945 44.752C179.705 45.184 179.457 45.496 179.201 45.688C178.961 45.864 178.681 45.952 178.361 45.952H177.449L173.177 38.368V49H169.937V32.2ZM196.609 32.2H205.537C206.993 32.2 208.161 32.592 209.041 33.376C209.937 34.16 210.385 35.192 210.385 36.472V38.152C210.385 38.984 210.145 39.712 209.665 40.336C209.201 40.944 208.521 41.408 207.625 41.728V41.776C208.137 42.112 208.521 42.496 208.777 42.928C209.049 43.36 209.313 43.96 209.569 44.728L210.913 49H207.481L206.209 45.016C206.001 44.328 205.713 43.816 205.345 43.48C204.977 43.144 204.521 42.976 203.977 42.976H199.921V49H196.609V32.2ZM204.913 40.12C205.585 40.12 206.113 39.944 206.497 39.592C206.881 39.224 207.073 38.752 207.073 38.176V36.616C207.073 36.152 206.929 35.784 206.641 35.512C206.353 35.224 205.969 35.08 205.489 35.08H199.921V40.12H204.913ZM218.709 49.192C217.445 49.192 216.325 48.928 215.349 48.4C214.389 47.856 213.637 47.104 213.093 46.144C212.565 45.168 212.301 44.04 212.301 42.76V38.44C212.301 37.16 212.565 36.04 213.093 35.08C213.637 34.104 214.389 33.352 215.349 32.824C216.325 32.28 217.445 32.008 218.709 32.008H221.253C222.517 32.008 223.629 32.28 224.589 32.824C225.565 33.352 226.317 34.104 226.845 35.08C227.389 36.04 227.661 37.16 227.661 38.44V42.76C227.661 44.04 227.389 45.168 226.845 46.144C226.317 47.104 225.565 47.856 224.589 48.4C223.629 48.928 222.517 49.192 221.253 49.192H218.709ZM221.253 46.264C222.181 46.264 222.925 45.928 223.485 45.256C224.061 44.584 224.349 43.704 224.349 42.616V38.584C224.349 37.496 224.061 36.616 223.485 35.944C222.925 35.272 222.181 34.936 221.253 34.936H218.709C217.781 34.936 217.029 35.272 216.453 35.944C215.893 36.616 215.613 37.496 215.613 38.584V42.616C215.613 43.704 215.893 44.584 216.453 45.256C217.029 45.928 217.781 46.264 218.709 46.264H221.253ZM236.076 49.192C234.812 49.192 233.692 48.928 232.716 48.4C231.756 47.856 231.004 47.104 230.46 46.144C229.932 45.168 229.668 44.04 229.668 42.76V38.44C229.668 37.16 229.932 36.04 230.46 35.08C231.004 34.104 231.756 33.352 232.716 32.824C233.692 32.28 234.812 32.008 236.076 32.008H238.62C239.884 32.008 240.996 32.28 241.956 32.824C242.932 33.352 243.684 34.104 244.212 35.08C244.756 36.04 245.028 37.16 245.028 38.44V42.76C245.028 44.04 244.756 45.168 244.212 46.144C243.684 47.104 242.932 47.856 241.956 48.4C240.996 48.928 239.884 49.192 238.62 49.192H236.076ZM238.62 46.264C239.548 46.264 240.292 45.928 240.852 45.256C241.428 44.584 241.716 43.704 241.716 42.616V38.584C241.716 37.496 241.428 36.616 240.852 35.944C240.292 35.272 239.548 34.936 238.62 34.936H236.076C235.148 34.936 234.396 35.272 233.82 35.944C233.26 36.616 232.98 37.496 232.98 38.584V42.616C232.98 43.704 233.26 44.584 233.82 45.256C234.396 45.928 235.148 46.264 236.076 46.264H238.62ZM247.515 32.2H250.467L255.963 42.184L261.339 32.2H264.291V49H261.051V38.368L257.523 44.752C257.283 45.184 257.035 45.496 256.779 45.688C256.539 45.864 256.259 45.952 255.939 45.952H255.027L250.755 38.368V49H247.515V32.2Z"
          fill="#2D2D2D"
        />
        <rect x="53" y="518" width="798" height="21" fill="#99631D" />
        <path
          d="M830.369 223.6C833.131 223.6 835.369 225.839 835.369 228.6L835.369 256.036C835.369 258.798 833.131 261.036 830.369 261.036L66.6306 261.036L66.6306 223.6L830.369 223.6Z"
          fill="#1B8CA3"
        />
        <path
          d="M583.86 217.501L583.86 261.036L119.206 261.036L119.206 217.501C300.686 206.636 402.386 206.764 583.86 217.501Z"
          fill="#14697A"
        />
        <rect
          x="819.739"
          y="181"
          width="42.6"
          height="160.568"
          rx="21.3"
          transform="rotate(90 819.739 181)"
          fill="#14697A"
        />
        <rect
          x="819.739"
          y="240.382"
          width="31.2611"
          height="508.618"
          fill="#C29B2E"
        />
        <rect
          x="819.739"
          y="261.036"
          width="37.4364"
          height="768.739"
          transform="rotate(90 819.739 261.036)"
          fill="#99631D"
        />
        <rect
          x="51"
          y="240.382"
          width="31.2611"
          height="508.618"
          fill="#C29B2E"
        />
        <rect
          x="228.62"
          y="240.382"
          width="31.2611"
          height="508.618"
          fill="#C29B2E"
        />
        <rect
          x="259.881"
          y="288.146"
          width="28.4"
          height="208.881"
          transform="rotate(90 259.881 288.146)"
          fill="#C29B2E"
        />
        <rect
          x="259.881"
          y="378.509"
          width="28.4"
          height="208.881"
          transform="rotate(90 259.881 378.509)"
          fill="#C29B2E"
        />
        <rect
          x="259.881"
          y="468.873"
          width="28.4"
          height="208.881"
          transform="rotate(90 259.881 468.873)"
          fill="#C29B2E"
        />
        <rect
          x="259.881"
          y="559.236"
          width="28.4"
          height="208.881"
          transform="rotate(90 259.881 559.236)"
          fill="#C29B2E"
        />
        <rect
          x="259.881"
          y="650.891"
          width="28.4"
          height="208.881"
          transform="rotate(90 259.881 650.891)"
          fill="#C29B2E"
        />
        <rect
          x="411"
          y="317"
          width="226"
          height="171.661"
          rx="5"
          fill="#797979"
        />
        <rect
          x="507.857"
          y="471.372"
          width="31.0507"
          height="46.929"
          rx="5"
          fill="#797979"
        />
        <rect
          x="577.721"
          y="509.656"
          width="9.58432"
          height="108.678"
          rx="4.79216"
          transform="rotate(90 577.721 509.656)"
          fill="#797979"
        />
        <rect
          x="419.91"
          y="327.145"
          width="206.706"
          height="124.202"
          rx="3.5"
          fill="#FAFAFA"
          stroke="#474747"
          strokeWidth="3"
        />
        <rect
          x="433.23"
          y="334.29"
          width="181.301"
          height="109.973"
          rx="5"
          fill="#2D2D2D"
        />
        <rect
          x="434.464"
          y="334.29"
          width="181.301"
          height="109.973"
          rx="5"
          fill="#2D2D2D"
        />
        <path
          d="M433.23 339.29C433.23 336.528 435.468 334.29 438.23 334.29H609.531C612.292 334.29 614.531 336.528 614.531 339.29V341.7H433.23V339.29Z"
          fill="#474747"
        />
        <path
          opacity="0.48"
          d="M433.23 341.699H462.869V444.202H438.23C435.468 444.202 433.23 441.964 433.23 439.202V341.699Z"
          fill="#474747"
        />
        <circle cx="441.257" cy="338.612" r="1.85246" fill="#B24747" />
        <circle cx="451.137" cy="338.612" r="1.85246" fill="#51B77B" />
        <circle cx="446.197" cy="338.612" r="1.85246" fill="#F3C13A" />
        <rect
          opacity="0.6"
          x="439.404"
          y="351.579"
          width="16.0546"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="356.519"
          width="16.0546"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="361.459"
          width="11.1148"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="440.639"
          y="366.399"
          width="14.8197"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="371.339"
          width="17.2896"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="376.279"
          width="12.3497"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="440.639"
          y="381.219"
          width="16.0546"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="386.158"
          width="8.64481"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="391.098"
          width="16.0546"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="396.038"
          width="13.5847"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="440.639"
          y="400.978"
          width="13.5847"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="405.918"
          width="14.8197"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="410.858"
          width="8.64481"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="415.798"
          width="16.0546"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="420.738"
          width="13.5847"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="440.639"
          y="425.678"
          width="13.5847"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <rect
          opacity="0.6"
          x="441.874"
          y="430.617"
          width="17.2896"
          height="1.23497"
          rx="0.617486"
          fill="#F3F3F3"
        />
        <path
          d="M483.982 378.634V373.132H482.98V372.294H483.982V371.644C483.982 370.964 484.164 370.439 484.527 370.068C484.89 369.696 485.404 369.511 486.068 369.511C486.318 369.511 486.566 369.544 486.812 369.61L486.753 370.489C486.57 370.454 486.375 370.437 486.167 370.437C485.816 370.437 485.544 370.54 485.353 370.747C485.162 370.95 485.066 371.243 485.066 371.626V372.294H486.419V373.132H485.066V378.634H483.982ZM491.535 378.007C491.113 378.503 490.494 378.751 489.677 378.751C489.001 378.751 488.486 378.556 488.13 378.165C487.779 377.771 487.601 377.189 487.597 376.419V372.294H488.681V376.39C488.681 377.351 489.072 377.831 489.853 377.831C490.681 377.831 491.232 377.523 491.505 376.905V372.294H492.589V378.634H491.558L491.535 378.007ZM495.267 372.294L495.302 373.091C495.787 372.482 496.419 372.177 497.201 372.177C498.541 372.177 499.216 372.933 499.228 374.444V378.634H498.144V374.439C498.14 373.982 498.035 373.644 497.828 373.425C497.625 373.206 497.306 373.097 496.873 373.097C496.521 373.097 496.212 373.191 495.947 373.378C495.681 373.566 495.474 373.812 495.326 374.116V378.634H494.242V372.294H495.267ZM503.406 377.866C503.792 377.866 504.13 377.749 504.419 377.515C504.708 377.28 504.869 376.987 504.9 376.636H505.925C505.906 376.999 505.781 377.345 505.55 377.673C505.32 378.001 505.011 378.263 504.625 378.458C504.242 378.653 503.835 378.751 503.406 378.751C502.542 378.751 501.855 378.464 501.343 377.89C500.835 377.312 500.582 376.523 500.582 375.523V375.341C500.582 374.724 500.695 374.175 500.921 373.694C501.148 373.214 501.472 372.841 501.894 372.575C502.32 372.31 502.822 372.177 503.4 372.177C504.111 372.177 504.701 372.39 505.169 372.816C505.642 373.241 505.894 373.794 505.925 374.474H504.9C504.869 374.064 504.712 373.728 504.431 373.466C504.154 373.2 503.81 373.068 503.4 373.068C502.849 373.068 502.421 373.267 502.117 373.665C501.816 374.06 501.666 374.632 501.666 375.382V375.587C501.666 376.318 501.816 376.88 502.117 377.275C502.417 377.669 502.847 377.866 503.406 377.866ZM508.615 370.759V372.294H509.798V373.132H508.615V377.064C508.615 377.318 508.667 377.509 508.773 377.638C508.878 377.763 509.058 377.825 509.312 377.825C509.437 377.825 509.609 377.802 509.828 377.755V378.634C509.542 378.712 509.265 378.751 508.996 378.751C508.511 378.751 508.146 378.605 507.9 378.312C507.654 378.019 507.531 377.603 507.531 377.064V373.132H506.376V372.294H507.531V370.759H508.615ZM512.248 378.634H511.164V372.294H512.248V378.634ZM511.076 370.612C511.076 370.437 511.128 370.288 511.234 370.167C511.343 370.046 511.503 369.985 511.714 369.985C511.925 369.985 512.085 370.046 512.195 370.167C512.304 370.288 512.359 370.437 512.359 370.612C512.359 370.788 512.304 370.935 512.195 371.052C512.085 371.169 511.925 371.228 511.714 371.228C511.503 371.228 511.343 371.169 511.234 371.052C511.128 370.935 511.076 370.788 511.076 370.612ZM513.701 375.405C513.701 374.784 513.822 374.226 514.064 373.73C514.31 373.234 514.65 372.851 515.083 372.581C515.521 372.312 516.019 372.177 516.578 372.177C517.441 372.177 518.138 372.476 518.669 373.073C519.205 373.671 519.472 374.466 519.472 375.458V375.534C519.472 376.151 519.353 376.706 519.115 377.198C518.88 377.687 518.542 378.068 518.101 378.341C517.664 378.614 517.16 378.751 516.589 378.751C515.73 378.751 515.033 378.452 514.498 377.855C513.966 377.257 513.701 376.466 513.701 375.482V375.405ZM514.791 375.534C514.791 376.237 514.953 376.802 515.277 377.228C515.605 377.653 516.042 377.866 516.589 377.866C517.14 377.866 517.578 377.651 517.902 377.222C518.226 376.788 518.388 376.183 518.388 375.405C518.388 374.71 518.222 374.148 517.89 373.718C517.562 373.284 517.125 373.068 516.578 373.068C516.042 373.068 515.611 373.28 515.283 373.706C514.955 374.132 514.791 374.741 514.791 375.534ZM521.857 372.294L521.892 373.091C522.376 372.482 523.009 372.177 523.791 372.177C525.13 372.177 525.806 372.933 525.818 374.444V378.634H524.734V374.439C524.73 373.982 524.625 373.644 524.417 373.425C524.214 373.206 523.896 373.097 523.462 373.097C523.111 373.097 522.802 373.191 522.537 373.378C522.271 373.566 522.064 373.812 521.916 374.116V378.634H520.832V372.294H521.857ZM531.513 373.062C531.994 372.472 532.619 372.177 533.388 372.177C534.728 372.177 535.404 372.933 535.416 374.444V378.634H534.332V374.439C534.328 373.982 534.222 373.644 534.015 373.425C533.812 373.206 533.494 373.097 533.06 373.097C532.708 373.097 532.4 373.191 532.134 373.378C531.869 373.566 531.662 373.812 531.513 374.116V378.634H530.429V369.634H531.513V373.062ZM539.669 378.751C538.81 378.751 538.111 378.47 537.572 377.907C537.033 377.341 536.763 376.585 536.763 375.64V375.441C536.763 374.812 536.882 374.251 537.121 373.759C537.363 373.263 537.699 372.876 538.128 372.599C538.562 372.318 539.031 372.177 539.535 372.177C540.359 372.177 541 372.448 541.457 372.991C541.914 373.534 542.142 374.312 542.142 375.323V375.775H537.847C537.863 376.4 538.044 376.905 538.392 377.292C538.744 377.675 539.189 377.866 539.728 377.866C540.111 377.866 540.435 377.788 540.701 377.632C540.966 377.476 541.199 377.269 541.398 377.011L542.06 377.526C541.529 378.343 540.732 378.751 539.669 378.751ZM539.535 373.068C539.097 373.068 538.73 373.228 538.433 373.548C538.136 373.864 537.953 374.31 537.882 374.884H541.058V374.802C541.027 374.251 540.878 373.825 540.613 373.525C540.347 373.22 539.988 373.068 539.535 373.068ZM544.58 378.634H543.496V369.634H544.58V378.634ZM547.498 378.634H546.414V369.634H547.498V378.634ZM548.951 375.405C548.951 374.784 549.072 374.226 549.314 373.73C549.56 373.234 549.9 372.851 550.333 372.581C550.771 372.312 551.269 372.177 551.828 372.177C552.691 372.177 553.388 372.476 553.919 373.073C554.455 373.671 554.722 374.466 554.722 375.458V375.534C554.722 376.151 554.603 376.706 554.365 377.198C554.13 377.687 553.792 378.068 553.351 378.341C552.914 378.614 552.41 378.751 551.839 378.751C550.98 378.751 550.283 378.452 549.748 377.855C549.216 377.257 548.951 376.466 548.951 375.482V375.405ZM550.041 375.534C550.041 376.237 550.203 376.802 550.527 377.228C550.855 377.653 551.292 377.866 551.839 377.866C552.39 377.866 552.828 377.651 553.152 377.222C553.476 376.788 553.638 376.183 553.638 375.405C553.638 374.71 553.472 374.148 553.14 373.718C552.812 373.284 552.375 373.068 551.828 373.068C551.292 373.068 550.861 373.28 550.533 373.706C550.205 374.132 550.041 374.741 550.041 375.534ZM556.041 375.171C556.041 374.288 556.158 373.441 556.392 372.628C556.63 371.816 556.984 371.077 557.453 370.413C557.921 369.749 558.408 369.28 558.912 369.007L559.134 369.722C558.564 370.159 558.095 370.827 557.728 371.726C557.365 372.624 557.166 373.63 557.13 374.743L557.125 375.241C557.125 376.749 557.4 378.058 557.951 379.167C558.283 379.831 558.677 380.351 559.134 380.726L558.912 381.388C558.392 381.099 557.896 380.614 557.423 379.935C556.501 378.607 556.041 377.019 556.041 375.171ZM562.685 375.23C562.685 376.101 562.57 376.937 562.339 377.737C562.113 378.534 561.763 379.271 561.291 379.946C560.822 380.622 560.33 381.103 559.814 381.388L559.585 380.726C560.187 380.265 560.669 379.55 561.033 378.581C561.4 377.609 561.587 376.53 561.595 375.347V375.159C561.595 374.339 561.509 373.577 561.337 372.874C561.166 372.167 560.925 371.534 560.617 370.976C560.312 370.417 559.968 369.982 559.585 369.669L559.814 369.007C560.33 369.292 560.82 369.769 561.285 370.437C561.753 371.105 562.103 371.841 562.333 372.646C562.568 373.45 562.685 374.312 562.685 375.23ZM570.214 380.778C569.523 380.583 569.001 380.261 568.65 379.812C568.302 379.366 568.128 378.776 568.128 378.042V376.876C568.128 375.927 567.714 375.452 566.886 375.452V374.603C567.714 374.603 568.128 374.13 568.128 373.185V371.966C568.136 371.251 568.31 370.675 568.65 370.237C568.994 369.796 569.515 369.476 570.214 369.276L570.437 369.95C569.621 370.212 569.212 370.894 569.212 371.995V373.179C569.212 374.066 568.886 374.683 568.234 375.03C568.886 375.382 569.212 376.005 569.212 376.9V378.107C569.224 379.181 569.632 379.847 570.437 380.105L570.214 380.778ZM492.466 387.267C492.302 387.239 492.125 387.226 491.933 387.226C491.222 387.226 490.74 387.528 490.486 388.134V392.634H489.402V386.294H490.457L490.474 387.026C490.83 386.46 491.333 386.177 491.986 386.177C492.197 386.177 492.357 386.204 492.466 386.259V387.267ZM495.982 392.751C495.123 392.751 494.423 392.47 493.884 391.907C493.345 391.341 493.076 390.585 493.076 389.64V389.441C493.076 388.812 493.195 388.251 493.433 387.759C493.675 387.263 494.011 386.876 494.441 386.599C494.875 386.318 495.343 386.177 495.847 386.177C496.671 386.177 497.312 386.448 497.769 386.991C498.226 387.534 498.455 388.312 498.455 389.323V389.775H494.16C494.175 390.4 494.357 390.905 494.705 391.292C495.056 391.675 495.501 391.866 496.041 391.866C496.423 391.866 496.748 391.788 497.013 391.632C497.279 391.476 497.511 391.269 497.71 391.011L498.373 391.526C497.841 392.343 497.044 392.751 495.982 392.751ZM495.847 387.068C495.41 387.068 495.042 387.228 494.746 387.548C494.449 387.864 494.265 388.31 494.195 388.884H497.371V388.802C497.339 388.251 497.191 387.825 496.925 387.525C496.66 387.22 496.3 387.068 495.847 387.068ZM501.185 384.759V386.294H502.369V387.132H501.185V391.064C501.185 391.318 501.238 391.509 501.343 391.638C501.449 391.763 501.628 391.825 501.882 391.825C502.007 391.825 502.179 391.802 502.398 391.755V392.634C502.113 392.712 501.835 392.751 501.566 392.751C501.082 392.751 500.716 392.605 500.47 392.312C500.224 392.019 500.101 391.603 500.101 391.064V387.132H498.947V386.294H500.101V384.759H501.185ZM507.554 392.007C507.132 392.503 506.513 392.751 505.697 392.751C505.021 392.751 504.505 392.556 504.15 392.165C503.798 391.771 503.621 391.189 503.617 390.419V386.294H504.701V390.39C504.701 391.351 505.091 391.831 505.873 391.831C506.701 391.831 507.251 391.523 507.525 390.905V386.294H508.609V392.634H507.578L507.554 392.007ZM513.326 387.267C513.162 387.239 512.984 387.226 512.792 387.226C512.082 387.226 511.599 387.528 511.345 388.134V392.634H510.261V386.294H511.316L511.333 387.026C511.689 386.46 512.193 386.177 512.845 386.177C513.056 386.177 513.216 386.204 513.326 386.259V387.267ZM515.353 386.294L515.388 387.091C515.873 386.482 516.505 386.177 517.287 386.177C518.626 386.177 519.302 386.933 519.314 388.444V392.634H518.23V388.439C518.226 387.982 518.121 387.644 517.914 387.425C517.71 387.206 517.392 387.097 516.958 387.097C516.607 387.097 516.298 387.191 516.033 387.378C515.767 387.566 515.56 387.812 515.412 388.116V392.634H514.328V386.294H515.353ZM524.687 383.523L525.308 383.944C524.945 384.441 524.757 384.976 524.746 385.55V386.347H523.667V385.667C523.667 385.269 523.761 384.874 523.949 384.484C524.14 384.093 524.386 383.773 524.687 383.523ZM533.054 392.634H531.923V388.691H527.623V392.634H526.498V384.103H527.623V387.771H531.923V384.103H533.054V392.634ZM536.06 392.634H534.976V386.294H536.06V392.634ZM534.888 384.612C534.888 384.437 534.941 384.288 535.046 384.167C535.156 384.046 535.316 383.985 535.527 383.985C535.738 383.985 535.898 384.046 536.007 384.167C536.117 384.288 536.171 384.437 536.171 384.612C536.171 384.788 536.117 384.935 536.007 385.052C535.898 385.169 535.738 385.228 535.527 385.228C535.316 385.228 535.156 385.169 535.046 385.052C534.941 384.935 534.888 384.788 534.888 384.612ZM539.013 390.226H538.035L537.958 384.103H539.095L539.013 390.226ZM537.917 392.089C537.917 391.913 537.97 391.767 538.076 391.65C538.185 391.528 538.345 391.468 538.556 391.468C538.767 391.468 538.927 391.528 539.037 391.65C539.146 391.767 539.201 391.913 539.201 392.089C539.201 392.265 539.146 392.411 539.037 392.528C538.927 392.642 538.767 392.698 538.556 392.698C538.345 392.698 538.185 392.642 538.076 392.528C537.97 392.411 537.917 392.265 537.917 392.089ZM540.97 386.505L540.355 386.083C540.718 385.575 540.906 385.04 540.917 384.478V383.634H541.99V384.396C541.986 384.786 541.888 385.177 541.697 385.568C541.509 385.954 541.267 386.267 540.97 386.505ZM482.74 408.105C483.533 407.851 483.943 407.204 483.97 406.165V404.876C483.97 403.974 484.324 403.359 485.031 403.03C484.324 402.71 483.97 402.095 483.97 401.185V399.995C483.97 398.894 483.562 398.212 482.746 397.95L482.968 397.276C483.66 397.472 484.179 397.79 484.527 398.232C484.875 398.669 485.05 399.249 485.054 399.972V401.202C485.054 402.136 485.468 402.603 486.296 402.603V403.452C485.468 403.452 485.054 403.927 485.054 404.876V406.06C485.054 406.794 484.876 407.382 484.521 407.823C484.169 408.265 483.652 408.583 482.968 408.778L482.74 408.105Z"
          fill="#DFDFDF"
        />
        <path
          d="M549 516C549 475.131 582.131 442 623 442C663.869 442 697 475.131 697 516V638.696H549V516Z"
          fill="#FF9393"
        />
        <path d="M549 638.696H572.627L565.94 752H549V638.696Z" fill="#917422" />
        <path d="M697 638.696H673.373L680.06 752H697V638.696Z" fill="#917422" />
        <path
          d="M745 475H782V512C782 517.523 777.523 522 772 522H755C749.477 522 745 517.523 745 512V475Z"
          fill="#14697A"
        />
        <path
          d="M778.5 478C780.535 478 782.551 478.427 784.432 479.256C786.312 480.085 788.021 481.301 789.46 482.833C790.899 484.365 792.041 486.184 792.82 488.186C793.599 490.188 794 492.333 794 494.5C794 496.667 793.599 498.812 792.82 500.814C792.041 502.816 790.899 504.635 789.46 506.167C788.021 507.699 786.312 508.915 784.432 509.744C782.551 510.573 780.535 511 778.5 511L778.5 503.772C779.644 503.772 780.776 503.532 781.833 503.066C782.89 502.6 783.85 501.917 784.659 501.056C785.467 500.195 786.109 499.173 786.547 498.048C786.984 496.923 787.21 495.718 787.21 494.5C787.21 493.282 786.984 492.077 786.547 490.952C786.109 489.827 785.467 488.805 784.659 487.944C783.85 487.083 782.89 486.4 781.833 485.934C780.776 485.468 779.644 485.228 778.5 485.228L778.5 478Z"
          fill="#14697A"
        />
        <path
          d="M758.426 471C759.426 469.163 760.89 466.949 759.288 463.767C757.687 460.585 757 460 757 460"
          stroke="#474747"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M764.426 470C765.426 468.163 766.89 465.949 765.288 462.767C763.687 459.585 763 459 763 459"
          stroke="#474747"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default Dorms
